import React, { useContext } from 'react'
import Tip from 'app/React/Components/misc/Tip'
import clx from 'classnames'
import { FeatureFlag } from 'utils/feature-flag'
import OptionStep2 from "app/React/Components/Form/Step2/OptionStep2";
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function SettingStep2(props) {
  const { order } = useContext(ConfiguratorContext)

  const setting = props.setting
  const options = Array.isArray(setting.options) ? { ...setting.options } : setting.options

  const optionValues = Object.values(options).filter(option => {
    if (!FeatureFlag.accessoryShop()) {
      return false
    }

    return option.hide_on !== order.paymentType && option.hide_on !== 'all'
  })

  const option_elements = optionValues.map((option, key) => (
    <OptionStep2
      key={key}
      option={option}
      layout={setting.layout}
      settingid={setting.id}
      onChange={props.onChange}
      required={false}
    />))

  if (
    optionValues.filter(
      (o) =>
        !(
          o.hide_on === order.paymentType ||
          o.hide_on === 'all' ||
          (!FeatureFlag.accessoryShop() && o.type === 'accessory-product')
        )
    ).length <= 0
  ) {
    return null
  }

  if (optionValues.length <= 0) {
    return null
  }

  return (
    <>
      <div className={clx('setting', props.className)} data-setting-id={setting.id}>
        <h3 className='config-subtitle'>
          {setting.label}
          {typeof setting.description === 'string' && setting.description.length > 0 ? (
            <Tip button='Ok' content={setting.description} />
          ) : null}
        </h3>
        <div className='config-radio' data-option-count={0}>
          {option_elements}
        </div>
      </div>
      <div className='config-seperator' />
    </>
  )
}

SettingStep2.defaultProps = {
  onChange: null,
  className: ''
}
